import React from "react";
import { Outlet } from "react-router-dom";

const AppSignUp = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default AppSignUp;